import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import { ListStore } from '../../stores/DashboardStore';
import { formatInteger } from '../../format';
import Button from '../Button';
import WidgetBase from './WidgetBase';
import './WidgetList.css';

const block = b.lock('WidgetList');

class WidgetList extends Component {
    static propTypes = {
        store: ListStore.PropType.isRequired,
        indexTitle: PropTypes.string.isRequired,
        labelTitle: PropTypes.string.isRequired,
        valueTitle: PropTypes.string.isRequired,
    };

    render() {
        const { store, ...props } = this.props;
        const firstIndex = store.pageSize * store.pageId;
        const lastIndex = Math.min(store.pageSize * (store.pageId + 1), store.items.length) - 1;
        const items = store.items.slice(firstIndex, lastIndex + 1);

        return <WidgetBase
            loading={store.updateState.isLoading}
            {...props}
        >
            <table className={block('Table')}>
                <thead>
                    <tr className={block('Tr')}>
                        {[
                            this.props.indexTitle,
                            this.props.labelTitle,
                            this.props.valueTitle,
                        ].map((title, index) => <th
                            key={title}
                            className={block('Th', { index })}
                        >{title}</th>)}
                    </tr>
                </thead>
                <tbody>
                    {items.map(({ value, label }, index) => <tr
                        key={index}
                        className={block('Tr')}
                    >
                        <td className={block('Td', { index: 0 })}>
                            {firstIndex + index + 1}
                        </td>
                        <td
                            className={block('Td', { index: 1 })}
                            title={label}
                        >{label}</td>
                        <td
                            className={block('Td', { index: 2 })}
                            title={formatInteger(value)}
                        >{formatInteger(value)}</td>
                    </tr>)}
                    {Array.from({ length: store.pageSize - items.length }, (value, index) => <tr
                        key={items.length + index}
                        className={block('Tr')}
                    />)}
                </tbody>
            </table>

            <div className={block('Pagination')}>
                <div className={block('PaginationLabel')}>
                    Display {items.length > 0 ? firstIndex + 1 : 0} - {lastIndex + 1} of {store.items.length}
                </div>
                <div className={block('PaginationButtonsWrapper')}>
                    <Button
                        className={block('PaginationButton')}
                        onClick={store.showPrevPage}
                        icon="keyboard_arrow_left"
                        disabled={store.pageCount <= 1}
                        noCenter
                    />
                    <Button
                        className={block('PaginationButton')}
                        onClick={store.showNextPage}
                        icon="keyboard_arrow_right"
                        disabled={store.pageCount <= 1}
                        noCenter
                    />
                </div>
            </div>
        </WidgetBase>;
    }
}

export default observer(WidgetList);
